export default __webpack_public_path__ + "static/gentle-0451db42d3e2da13446f27c4aadc7128.png";